import { PascalCasingRegex, RemoveUnwantedCharsRegex, SplitRegex } from './regex';

export function slugify(altText: string): string {
  const sanitizedText = altText.replace(RemoveUnwantedCharsRegex, '');

  return sanitizedText.split(SplitRegex)
    .map((possiblePascals) => possiblePascals.replace(PascalCasingRegex, '$1-$2'))
    .map((matchedWord) => matchedWord.toLowerCase())
    .join('-');
}
